/* @size3xsWithTap --> Assumes standard <Button /> as base,
and you feed in a classNameOverwrite. Example: <Button className={size3xsWithTap} />
OR for new custom colors:  <Button className={twMerge(size3xsWithTap, "bg-secondary-base-1 text-reserved-true-white")} />  */
export const size3xsWithTap: string =
  'w-auto h-auto py-100 px-200 enki-button-secondary !bg-secondary-base-1 text-reserved-true-white enki-body-3xs-strong leading-125 max-w-[80px]';
